import moment from "moment";
import { isEmptyDay } from "../hooks/useMealDay";
import { Tokens } from "../../Shared/sharedTypes/Tokens";
/**
 * * Evaluates if changes can be saved based on configured meal and amount requirements
 * * for each day. Generates warning messages for days that do not meet the criteria.
 * @param myMealsConfig: MealDayConfigType;
 * @param days: Array<MyMealsDayType>;
 * @param mealQuantitiesPerDay: number;
 * @param selectedOrderMealQuantity: number;
 * @param amountsPerDay: number;
 * @param amountForOrder: number;
 * @param totalQuantitiesPerDay: number;
 * @param deliveryMethod: string;
 * @returns
 */
export const proceedWithSaveChanges = (myMealsConfig, days, mealQuantitiesPerDay, selectedOrderMealQuantity, amountsPerDay, amountForOrder, totalQuantitiesPerDay, deliveryMethod = "Delivery") => {
    let proceed = true;
    let warningText = "";
    const dayWarningMessages = [];
    days === null || days === void 0 ? void 0 : days.forEach((day) => {
        warningText = "";
        let daysPerOrder = Object.entries(totalQuantitiesPerDay).filter(([day, totalQuantity]) => {
            return totalQuantity > 0;
        }).length;
        let totalMealQuantityForDay = mealQuantitiesPerDay[day.DateFormatted];
        let amountForDay = amountsPerDay[day.DateFormatted];
        deliveryMethod = deliveryMethod.charAt(0).toUpperCase() + deliveryMethod.slice(1).toLowerCase();
        let minDaysPerOrderObj = myMealsConfig[`MinDaysPerOrder${deliveryMethod}`];
        let minDaysPerOrder = minDaysPerOrderObj.NumericValue;
        let useMinDaysPerOrder = minDaysPerOrderObj.Enabled;
        let minDaysPerOrderWarningText = minDaysPerOrderObj.ErrorMsg;
        let minMealsPerDayObj = myMealsConfig[`MinMealsPerDay${deliveryMethod}`];
        let minMealsPerDay = minMealsPerDayObj.NumericValue;
        let useMinMealsPerDay = minMealsPerDayObj.Enabled;
        let minMealsPerDayWarningText = minMealsPerDayObj.ErrorMsg;
        let maxMealsPerDayObj = myMealsConfig[`MaxMealsPerDay${deliveryMethod}`];
        let maxMealsPerDay = maxMealsPerDayObj.NumericValue;
        let useMaxMealsPerDay = maxMealsPerDayObj.Enabled;
        let maxMealsPerDayWarningText = maxMealsPerDayObj.ErrorMsg;
        let minMealsPerOrderObj = myMealsConfig[`MinMealsPerOrder${deliveryMethod}`];
        let minMealsPerOrder = minMealsPerOrderObj.NumericValue;
        let useMinMealsPerOrder = minMealsPerOrderObj.Enabled;
        let minMealsPerOrderWarningText = minMealsPerOrderObj.ErrorMsg;
        let maxMealsPerOrderObj = myMealsConfig[`MaxMealsPerOrder${deliveryMethod}`];
        let maxMealsPerOrder = maxMealsPerOrderObj.NumericValue;
        let useMaxMealsPerOrder = maxMealsPerOrderObj.Enabled;
        let maxMealsPerOrderWarningText = maxMealsPerOrderObj.ErrorMsg;
        let minAmountPerDayObj = myMealsConfig[`MinAmountPerDay${deliveryMethod}`];
        let minAmountPerDay = minAmountPerDayObj.NumericValue;
        let useMinAmountPerDay = minAmountPerDayObj.Enabled;
        let minAmountPerDayWarningText = minAmountPerDayObj.ErrorMsg;
        let maxAmountPerDayObj = myMealsConfig[`MaxAmountPerDay${deliveryMethod}`];
        let maxAmountPerDay = maxAmountPerDayObj.NumericValue;
        let useMaxAmountPerDay = maxAmountPerDayObj.Enabled;
        let maxAmountPerDayWarningText = maxAmountPerDayObj.ErrorMsg;
        let minAmountPerOrderObj = myMealsConfig[`MinAmountPerOrder${deliveryMethod}`];
        let minAmountPerOrder = minAmountPerOrderObj.NumericValue;
        let useMinAmountPerOrder = minAmountPerOrderObj.Enabled;
        let minAmountPerOrderWarningText = minAmountPerOrderObj.ErrorMsg;
        let maxAmountPerOrderObj = myMealsConfig[`MaxAmountPerOrder${deliveryMethod}`];
        let maxAmountPerOrder = maxAmountPerOrderObj.NumericValue;
        let useMaxAmountPerOrder = maxAmountPerOrderObj.Enabled;
        let maxAmountPerOrderWarningText = maxAmountPerOrderObj.ErrorMsg;
        let limit = 0;
        // A day should only be considered in requirements calculation if it has meals or products.
        if (!isEmptyDay(day)) {
            if (useMinDaysPerOrder && daysPerOrder < minDaysPerOrder) {
                proceed = false;
                warningText = minDaysPerOrderWarningText;
                limit = minDaysPerOrder;
            }
            if (useMinMealsPerDay && totalMealQuantityForDay < minMealsPerDay) {
                proceed = false;
                warningText = minMealsPerDayWarningText;
                limit = minMealsPerDay;
            }
            if (useMaxMealsPerDay && totalMealQuantityForDay > maxMealsPerDay) {
                proceed = false;
                warningText = maxMealsPerDayWarningText;
                limit = maxMealsPerDay;
            }
            if (useMinMealsPerOrder && selectedOrderMealQuantity < minMealsPerOrder) {
                proceed = false;
                warningText = minMealsPerOrderWarningText;
                limit = minMealsPerOrder;
            }
            if (useMaxMealsPerOrder && selectedOrderMealQuantity > maxMealsPerOrder) {
                proceed = false;
                warningText = maxMealsPerOrderWarningText;
                limit = maxMealsPerOrder;
            }
            if (useMinAmountPerDay && amountForDay < minAmountPerDay) {
                proceed = false;
                warningText = minAmountPerDayWarningText;
                limit = minAmountPerDay;
            }
            if (useMaxAmountPerDay && amountForDay > maxAmountPerDay) {
                proceed = false;
                warningText = maxAmountPerDayWarningText;
                limit = maxAmountPerDay;
            }
            if (useMinAmountPerOrder && amountForOrder < minAmountPerOrder) {
                proceed = false;
                warningText = minAmountPerOrderWarningText;
                limit = minAmountPerOrder;
            }
            if (useMaxAmountPerOrder && amountForOrder > maxAmountPerOrder) {
                proceed = false;
                warningText = maxAmountPerOrderWarningText;
                limit = maxAmountPerOrder;
            }
            if (!proceed && warningText !== "") {
                warningText = warningText.replace(Tokens.Limit, String(limit));
                warningText = warningText.replace(Tokens.Day, moment(day.DateFormatted).format("ddd. MMM Do"));
                dayWarningMessages.push({ day: day.DateFormatted, warningText });
            }
        }
    });
    return {
        proceed: proceed,
        dayWarningMessages,
    };
};
